// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0b827e3d","488":"78f89ec6","666":"13c82ffa","710":"8091ff5f","739":"aa78366c","872":"5f575673","877":"c9867b01","921":"5d56d526"}[chunkId] + ".chunk.js";
};